/**
 * Renglón nuevo de una devolución a partir de una entrega de origen o de un material legacy.
 * @param {Object} source Entrega con saldo (`return-sources`) o artículo del catálogo.
 * @param {boolean} legacy Si el material no tiene entrega registrada en el sistema.
 * @returns {Object} Renglón con cantidad vacía y tope del saldo sin comprometer.
 */
export const buildReturnItem = (source, legacy) => ({
  key: legacy ? `legacy:${source.uuid}` : source.uuid,
  uuid_consumption_item: legacy ? null : source.uuid,
  uuid_inventory_article: legacy ? source.uuid : source.uuid_inventory_article,
  article_name: source.article_name || source.name,
  article_code: source.article_code || source.code,
  consumption_number: source.consumption_number,
  unit: source.unit,
  quantity: '',
  limit: legacy ? null : source.available_quantity,
});
